const PlaceholderManagementType = {
  CATEGORY1: 'CATEGORY1',
  CATEGORY2: 'CATEGORY2',
  BRANDS: 'BRANDS',
  SEASONS: 'SEASONS',
  DYNAMIC_COLUMN: 'DYNAMIC_COLUMN',
  PRODUCT_TYPE: 'PRODUCT_TYPE',
  SAVE_PRODUCT_TYPE: 'SAVE_PRODUCT_TYPE',
  PLACEHOLDER_DATA: 'PLACEHOLDER_DATA',
  SET_FILTER_SORT_DATA: 'SET_FILTER_SORT_DATA',
  SUPPLIERTYPE: 'SUPPLIERTYPE',
  PRODUCT_DETAIL: 'PRODUCT_DETAIL',
  SEARCHED_PRODUCTS: 'SEARCHED_PRODUCTS',
  CLEAR_REDUCER: 'CLEAR_REDUCER',
  UPDATE_PUBLISHED_STATE: 'UPDATE_PUBLISHED_STATE',
  SET_INDIVIDUAL_DETAILS: 'SET_INDIVIDUAL_DETAILS',
  GET_PLACEHOLDER_CARD_DATA: 'GET_PLACEHOLDER_CARD_DATA',
  DELETE_PLACEHOLDER_DATA: 'DELETE_PLACEHOLDER_DATA',
  CLEAR_INDIVIDUAL_REDUCER: 'CLEAR_INDIVIDUAL_REDUCER',
};

export default PlaceholderManagementType;
